import { Input, InputGroup } from '@/components/base/input'
import { CurrentTenantContext } from '@/core/current_tenant_context'
import { useContext, useEffect } from 'react'
import { useState } from 'react'
import { useLocale } from '../useLocale'

interface CurrencyProps {
  value: number
  onChange: (value: number) => void
  disabled: boolean
  invalid: boolean
}

export const CurrencyInput = ({ value, onChange, disabled, invalid }: CurrencyProps) => {
  const [internalValue, setInternalValue] = useState((value / 100).toFixed(2))
  const { currentCompany } = useContext(CurrentTenantContext)
  const { currency } = useLocale(currentCompany?.locale)

  useEffect(() => {
    if (parseFloat(internalValue || '0') != value / 100) setInternalValue((value / 100).toFixed(2))
  }, [value, internalValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInternalValue(e.target.value)
    onChange(Math.floor(parseFloat(e.target.value || '0') * 100))
  }

  return (
    <InputGroup>
      <span className="text-zinc-500 text-sm/4" data-slot="icon">{currency.symbol}</span>
      <Input
        disabled={disabled}
        invalid={invalid}
        step={0.01}
        type="number"
        value={internalValue}
        onChange={handleChange}
      />
    </InputGroup>
  )
}
